import fr			from './fr'
import en			from './en'

const	lang = {fr, en}

export default lang